/* WAYCEL — About Us
   Lightweight, dependency-free scroll & interaction effects.
   Respects prefers-reduced-motion. Initializes on DOMContentLoaded.
*/
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Reveal-on-scroll using IntersectionObserver */
  function initReveal(root) {
    var els = root.querySelectorAll('.wa-reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('wa-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('wa-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Count-up numbers when they enter the viewport */
  function initCountUp(root) {
    var nodes = root.querySelectorAll('.wa-count-up');
    if (!nodes.length) return;
    if (reduced || !('IntersectionObserver' in window)) return;

    function animate(el) {
      var raw = el.dataset.value || el.textContent;
      var m = raw.match(/([\d.,]+)/);
      if (!m) return;
      var numStr = m[1];
      var target = parseFloat(numStr.replace(/,/g, ''));
      if (isNaN(target)) return;
      var decimals = (numStr.split('.')[1] || '').length;
      var prefix = raw.slice(0, m.index);
      var suffix = raw.slice(m.index + numStr.length);
      var dur = 1600;
      var t0 = performance.now();
      function fmt(n) {
        var s = decimals ? n.toFixed(decimals) : Math.round(n).toString();
        return numStr.indexOf(',') !== -1
          ? Number(s).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
          : s;
      }
      function tick(t) {
        var p = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + fmt(target * e) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animate(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });

    nodes.forEach(function (n) {
      n.dataset.value = n.textContent.trim();
      n.textContent = n.textContent.replace(/[\d.,]+/, '0');
      io.observe(n);
    });
  }

  /* Polaroid cursor parallax */
  function initPolaroidCursor(root) {
    if (reduced) return;
    var stacks = root.querySelectorAll('.wa-polaroids');
    stacks.forEach(function (stack) {
      var raf = 0, tx = 0, ty = 0, cx = 0, cy = 0;
      function tick() {
        cx += (tx - cx) * 0.12;
        cy += (ty - cy) * 0.12;
        stack.style.setProperty('--mx', cx.toFixed(3));
        stack.style.setProperty('--my', cy.toFixed(3));
        if (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) {
          raf = requestAnimationFrame(tick);
        } else {
          raf = 0;
        }
      }
      stack.addEventListener('mousemove', function (e) {
        var r = stack.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
        if (!raf) raf = requestAnimationFrame(tick);
      });
      stack.addEventListener('mouseleave', function () {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(tick);
      });
    });
  }

  /* Mouse-tilt for editorial card */
  function initTilt(root) {
    if (reduced) return;
    var els = root.querySelectorAll('.wa-tilt');
    els.forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform =
          'perspective(1100px) rotateX(' + (-y * 4).toFixed(2) + 'deg) ' +
          'rotateY(' + (x * 5).toFixed(2) + 'deg) translateY(-4px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.waInitialized === 'true') return;
    root.dataset.waInitialized = 'true';
    initReveal(root);
    initCountUp(root);
    initPolaroidCursor(root);
    initTilt(root);
  }

  function initInScope(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('.waycel-about')) {
      initRoot(scope);
    }
    var roots = scope.querySelectorAll ? scope.querySelectorAll('.waycel-about') : [];
    roots.forEach(function (root) {
      initRoot(root);
    });
  }

  ready(function () {
    initInScope(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initInScope(event.target);
  });
})();
